import axios from 'axios'
import * as API_LINKS from '../../../configurations/links'
import {toast} from 'react-toastify'
import cookie from 'react-cookies'

export const FETCH_TASK_ACTIVITY = 'FETCH_TASK_ACTIVITY'
export const RECEIVE_TASK_ACTIVITY = 'RECEIVE_TASK_ACTIVITY'
export const FAILED_TASK_ACTIVITY = 'RECEIVE_TASK_ACTIVITY'

export function fetchTaskActivity(_data){
    return(dispatch, getState) => {
        dispatch({type: FETCH_TASK_ACTIVITY})
        axios({
            method: 'POST',
            url: API_LINKS.SCHEDULE_ACTIVITY_LIST_URL,
            headers: {
                Authorization: cookie.load('token')
            },
            data: {
                ..._data
            }
        })
        .then((response) => {
            if(response.status === 200){
                if(response.data.status === "success"){
                    dispatch({
                        type: RECEIVE_TASK_ACTIVITY,
                        payload: response.data.result
                    })
                } else {
                    dispatch({
                        type: FAILED_TASK_ACTIVITY
                    })
                }
            } else {
                dispatch({
                    type: FAILED_TASK_ACTIVITY
                })
            }
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_TASK_ACTIVITY
                    })
                    return toast.error(error.response.data.message);
                } else if (error.response.status === 403) {
                    dispatch({
                        type: FAILED_TASK_ACTIVITY
                    })
                    return toast.error(error.response.data.message);
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_TASK_ACTIVITY
                    })
                    return toast.error(error.response.data.message);
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_TASK_ACTIVITY
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else {
                    dispatch({
                        type: FAILED_TASK_ACTIVITY
                    })
                    return toast.error('Something went wrong... Please try again later...')
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_TASK_ACTIVITY
                })
                return toast.error('Request have no response! Please check on your internet connection and refresh this page.')
            } else {
                dispatch({
                    type: FAILED_TASK_ACTIVITY
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/redux/actions/tasks/aTask-ActivityList.jsx